import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-auth-toolbar',
  templateUrl: './auth-toolbar.component.html',
  styleUrls: ['./auth-toolbar.component.scss'],
  standalone: true,
  imports: [MatToolbarModule, RouterLinkActive, MatIconModule]
})
export class AuthToolbarComponent implements OnInit {
  private isBrowser: boolean;

  public displayToolbar = false;
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.displayToolbar = window.innerWidth <= 730;
  }

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.displayToolbar = window.innerWidth <= 730;
    }
  }

  public onNavigate(): void {
    this.router.navigate(['']);
  }

}
